/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import moment from 'moment'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import $ from 'jquery'
import jMoment from 'moment-jalaali'
import Select from 'react-select'
import {Icon, message} from 'antd'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import SearchableCombo from '../BaseComponent/searchableCombo'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'
class Cardex extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      providerId: '',
      loading: false,
      refTypeWarehouseId: null,
      Cardex: [],
      printInfo: [],
      selectedDateFrom: moment(),
      selectedDateTo: null,
      lengthCardex: 0,
      pageNumber: 1,
      pageSize: 10,
      // sortBy: "confirmDate_desc,preWarehouseDocId_desc,productName_asc",
      sortBy: 'globalDocNo_desc,manualRegisterDate_desc,preWarehouseDocId_desc',
      getSort: '',
      modal: false,
      providers: [],
      selectedOption: [],
      wareHousesname: [],
      providerText: '',
      wareTextPrint: '',
      finalTarikh: '',
      buttonClicked: false,
      warehouseId: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ ثبت سند',
          value: 'confirmDate',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'شماره سراسری سند',
          value: 'globalDocNo',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ دستی سند',
          value: 'manualRegisterDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'کد محصول',
          value: 'articleId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: ' بارکد محصول',
          value: 'productCode',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام محصول',
          value: 'productName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نام انبار',
          value: 'warehouseName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام انبار طرف',
          value: 'warehouseName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وارد شده',
          value: 'inQuantity',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'خارج شده',
          value: 'productCode',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'مانده',
          value: 'remainQuantity',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شماره پیش سند',
          value: 'preWarehouseDocId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شماره  سند',
          value: 'natureDocNo',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ماهیت  سند',
          value: 'input',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تامین کننده کالا',
          value: 'providerName',
          sorted: false,
          direction: null,
          sortable: true
        }
      ],
      wareType: []
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleDateChangeFrom = (date) => {
    this.setState({selectedDateFrom: date, selectedDateTo: date})
    // this.toDateInput.focus();
  }

  handleDateChangeTo = (date) => {
    this.setState({selectedDateTo: date})
    // this.toDateInput.focus();
  }

  preventType = (e) => {
    e.preventDefault()
  }
  handleChange = (selectedOption) => {
    this.setState({selectedOption})

    console.log(`Option selected:`, selectedOption)
  }

  getTypePrimaries = () => {
    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_PRIMARYWAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            wareType: response.data.object
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error === null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].id
            result[i]['label'] = result[i].id + ' - ' + result[i].name + ' ( ' + result[i].typePrimaryName + ' ) '
          }
          this.setState({
            wareHousesname: response.data.object
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })

    // http
    //   .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
    //   .then((response) => {
    //     if (response.data.error === null) {
    //       var result = response.data.object;
    //       for (let i = 0; i < result.length; i++) {
    //         result[i]["value"] = result[i].providerId;
    //         result[i]["label"] = result[i].providerId + " - " + result[i].title;
    //       }

    //       this.setState({
    //         providers: response.data.object,
    //       });
    //     }
    //   })
    //   .catch((error) => {});

    sessionStorage.removeItem('params')
    this.getTypePrimaries()
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  getAllCardex = (exportStatus) => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(exportStatus)
    http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_CARDEX}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable').fadeIn()
          if (!exportStatus) {
            let cardex = response.data.object.result
            let obj = {}
            let number = 0

            cardex.forEach((item, index) => {
              obj[item.globalDocNo] = {
                count: cardex.filter((i) => i.globalDocNo === item.globalDocNo).length,
                index: number++
              }
            })
            console.log(obj)
            let keys = Object.keys(obj)
            keys.forEach((key, index) => {
              obj[key].index = index
              cardex.forEach((item) => {
                if (key == item.globalDocNo) {
                  item.colorable = true
                  if (obj[key].index % 2 === 0) {
                    item.background = '#f5d576'
                  } else {
                    item.background = '#d9d9d9'
                  }
                } else {
                  // item.colorable = false
                }
              })
            })
            // for (const key in obj) {

            // }

            this.setState(
              {
                tablePageNumber: this.state.pageNumber,
                tablePageSize: this.state.pageSize,
                Cardex: cardex,
                lengthCardex: response.data.object.countAll,
                providerText:
                  this.state.selectedOption == null || this.state.selectedOption == ''
                    ? ''
                    : this.state.selectedOption.title,
                wareTextPrint: this.state.wareText,
                finalTarikh: filter.manualRegisterDateMax,
                buttonClicked: true,
                loading: false
              },
              () => {}
            )
          } else if (exportStatus) {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          $('.showBaseTable').fadeOut()
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          this.setState({
            loading: false
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  onResultFetched(data) {
    this.setState({
      Cardex: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Cardex: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  handleCancel = (e) => {
    console.log(e)
    this.setState({
      visible: false
    })

    this.setState({
      modal: !this.state.modal
    })
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  fromDate(props) {
    return <input className="form-control" {...props} />
  }

  toDate(props) {
    return <input className="form-control" {...props} />
  }

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  getValueWarehouse = (warehouseId) => {
    this.setState({
      warehouseId,
      wareText: warehouseId === '' || warehouseId === null ? ' ' : warehouseId.name
    })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAllCardex(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAllCardex(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAllCardex(false)
    }
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let productArticleId = this.convertDigit(document.getElementById('articleIdCode').value)
    let productCode = this.convertDigit(document.getElementById('productCode').value)
    let productName = document.getElementById('productName').value
    let typePrimary = document.getElementById('typePrimary').value

    let refType = document.getElementById('refType').value

    let refTypePrimaryWarehouseId = document.getElementById('refTypePrimaryWarehouseId').value
    let refTypeWarehouseId = this.state.refTypeWarehouseId === null ? '' : this.state.refTypeWarehouseId.id

    let refProviderId = this.state.refProviderId
    let refCustomerId = document.getElementById('refCustomerId').value
    let refFactorNo = document.getElementById('refFactorNo').value

    let warehousename = this.state.warehouseId == null || this.state.warehouseId == '' ? '' : this.state.warehouseId.id
    var providerId = this.state.providerId
    let inquantitymin = this.convertDigit(document.getElementById('inquantityMin').value)
    let outquantitymin = this.convertDigit(document.getElementById('outquantityMin').value)
    let isInput = document.getElementById('isInput').value
    let isAutomatic = document.getElementById('isAutomatic').value
    let isInternal = document.getElementById('isInternal').value
    let manualRegisterDateMax = document.getElementById('datePickerTo').value

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.sortBy = this.state.sortBy
    filter.export = exportStatus

    if (productArticleId !== '' && productArticleId.length) {
      filter.articleId = productArticleId.trim()
    }
    if (productName !== '' && productName.length) {
      filter.productName = productName.trim()
    }
    if (productCode !== '' && productCode.length) {
      filter.productCode = productCode.trim()
    }
    if (warehousename !== '') {
      filter.typeWarehouseId = warehousename
    }
    if (refTypeWarehouseId !== '') {
      filter.refTypeWarehouseId = refTypeWarehouseId
    }
    if (providerId !== '') {
      filter.providerId = providerId
    }
    if (typePrimary !== '') {
      filter.typePrimary = typePrimary
    }
    if (refTypePrimaryWarehouseId !== '') {
      filter.refTypePrimaryWarehouseId = refTypePrimaryWarehouseId
    }
    if (inquantitymin !== '' && inquantitymin.length) {
      filter.inQuantityMin = inquantitymin.trim()
    }
    if (outquantitymin !== '' && outquantitymin.length) {
      filter.outQuantityMin = outquantitymin
    }
    if (isInput !== '') {
      filter.isInput = isInput
    }
    if (isInternal !== '') {
      filter.isInternal = isInternal
    }
    if (isAutomatic !== '') {
      filter.isAutomatic = isAutomatic
    }
    if (manualRegisterDateMax !== '') {
      filter.manualRegisterDateMax = this.epochTo(this.convertDigit(manualRegisterDateMax))
    }
    if (refType !== '') {
      filter.refType = refType
    }

    if (refFactorNo) {
      filter.refFactorNo = refFactorNo
    }

    if (refProviderId) {
      filter.refProviderId = refProviderId
    }
    if (refCustomerId) {
      filter.refCustomerId = refCustomerId
    }

    return filter
  }

  filter() {
    if (this.createFilter === {}) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getAllCardex(false)
        }
      )
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  getPrintInfo = () => {
    this.getAllCardex(true)
  }
  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_CARDEX}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['confirmDate'] = jMoment(excelReport[i]['confirmDate']).format('jYY/jMM/jDD HH:mm')
            if (excelReport[i]['manualRegisterDate'] === null) {
              excelReport[i]['manualRegisterDate'] = ''
            } else {
              excelReport[i]['manualRegisterDate'] = jMoment(excelReport[i]['manualRegisterDate']).format(
                'jYY/jMM/jDD HH:mm'
              )
            }
            if (excelReport[i]['input']) {
              excelReport[i]['input'] = 'وارده'
            } else {
              excelReport[i]['input'] = 'صادره'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  dynamicBreadTitle = () => {
    let urlParams = new URLSearchParams(window.location.search)
    let from = !urlParams.get('from') ? '' : urlParams.get('from')
    if (!from) return ''
    else if (from === 'inventory') return <li>انبار</li>
    else return <li>مالی</li>
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let {selectedOption} = this.state
    const {selectedDateTo} = this.state
    let dropDownVal = sessionStorage.getItem('dropDownVal')

    let params = sessionStorage.getItem('params')
    let name = cookie.load('name')

    let excelColumns = [
      {title: 'تاریخ ثبت', value: 'confirmDate'},
      {title: 'کد محصول', value: 'productCode'},
      {title: 'نام محصول', value: 'productName'},
      {title: 'تعداد وارد شده', value: 'inQuantity'},
      {title: 'تعداد خارج شده', value: 'outQuantity'},

      {title: 'تامین کننده کالا', value: 'providerName'}
    ]
    let columns = [
      'ردیف',
      'تاریخ ثبت',
      'شماره سراسری سند',
      'تاریخ دستی',
      'کد محصول',
      'بارکد محصول',
      'نام محصول',
      'نام انبار',
      'انبار طرف',
      'وارد شده',
      'خارج شده',
      'مانده',

      'ماهیت سند',
      'تامین کننده کالا'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش کاردکس"
              headerColSpan={16}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={5}
              rightColSpan={5}
              centerColSpan={6}
              centerSection={'تامین کننده کالا : ' + this.state.providerText}
              rightSection={'موجودی برای انبار : ' + this.state.wareTextPrint}
              columns={columns}
            />
            <thead />
            <tbody>
              {this.state.printInfo.map((cardex, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{jMoment(cardex.confirmDate).format('jYYYY/jMM/jDD HH:mm')}</td>
                  <td>{cardex.globalDocNo}</td>
                  <td>
                    {cardex.manualRegisterDate == null
                      ? '-'
                      : jMoment(cardex.manualRegisterDate).format('jYYYY/jMM/jDD')}
                  </td>
                  <td>{cardex.articleId}</td>
                  <td>{cardex.productCode}</td>
                  <td>{cardex.productName}</td>
                  <td>{cardex.warehouseName}</td>
                  <td>{cardex.refTypeWarehouseName}</td>
                  <td>{cardex.inQuantity}</td>
                  <td>{cardex.outQuantity}</td>
                  <td>{cardex.remainQuantity}</td>

                  <td>{cardex.input ? 'وارده' : 'صادره'}</td>
                  <td>{cardex.providerName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش کاردکس.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'confirmDate'}
                field={'confirmDate'}
                title={'تاریخ ثبت سند'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'globalDocNo'}
                field={'globalDocNo'}
                title={'شماره سراسری سند'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'manualRegisterDate'}
                field={'manualRegisterDate'}
                title={'تاریخ دستی سند'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'articleId'}
                field={'articleId'}
                title={'کد محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn key={'productCode'} field={'productCode'} title={'بارکد'} />

              <gridColumn key={'productName'} field={'productName'} title={'نام محصول'} />
              <gridColumn key={'warehouseName'} field={'warehouseName'} title={'نام انبار'} />

              <gridColumn key={'refTypeWarehouseName'} field={'refTypeWarehouseName'} title={'نام انبار طرف'} />
              <gridColumn key={'inQuantity'} field={'inQuantity'} title={'وارد شده'} />
              <gridColumn key={'outQuantity'} field={'outQuantity'} title={'خارج شده'} />
              <gridColumn key={'remainQuantity'} field={'remainQuantity'} title={'مانده'} />

              <gridColumn key={'input'} field={'input'} title={'ماهیت  سند'} />
              <gridColumn key={'providerName'} field={'providerName'} title={'تامین کننده کالا'} />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            {this.dynamicBreadTitle()}

            <li>لیست کاردکس</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>تاریخ تا:</label>

                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                      onChange={this.handleDateChangeTo}
                      onKeyPress={this.preventType}
                      TextFieldComponent={this.toDate}
                      id="datePickerTo"
                      name="datePickerTo"
                      value={selectedDateTo}
                      ref={(node) => (this.toDateInput = node)}
                      readOnly
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className="formComponent">
                  <label>کد محصول:</label>
                  <input className="form-control" type="text" id="articleIdCode" />
                </div>
                <div className="formComponent">
                  <label>بارکد محصول:</label>
                  <input className="form-control" type="text" id="productCode" />
                </div>
                <div className="formComponent">
                  <label>نام کالا:</label>
                  <input className="form-control" type="text" id="productName" />
                </div>
                <div className="formComponent">
                  <label>تعداد وارده:</label>
                  <input className="form-control" type="number" id="inquantityMin" />
                </div>
                <div className="formComponent">
                  <label>تعداد صادره:</label>
                  <input className="form-control" type="number" id="outquantityMin" />
                </div>

                <div className="formComponent">
                  <label>ماهیت سند:</label>
                  <select className="form-control" id="isInput">
                    <option value="" />
                    <option value={true}>وارده</option>
                    <option value={false}>صادره</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>بین انباری:</label>
                  <select className="form-control" id="isInternal">
                    <option value="">------</option>
                    <option value={true}>بله</option>
                    <option value={false}>خیر</option>
                  </select>
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.wareHousesname}
                    getValueCombo={this.getValueWarehouse}
                    lableText="نام انبار"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>

                <div className="formComponent">
                  <label>نوع انبار </label>
                  <select className="form-control" id="typePrimary" name="typePrimary">
                    <option value="">---------</option>
                    {this.state.wareType.map((wareType, index) => (
                      <option key={index} value={wareType.id}>
                        {wareType.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>نوع ثبت:</label>
                  <select className="form-control" id="isAutomatic">
                    <option value="">------</option>
                    <option value={false}>دستی</option>

                    <option value={true}>اتوماتیک</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>نوع طرف </label>
                  <select
                    className="form-control"
                    id="refType"
                    name="refType"
                    onChange={(e) => this.setState({refType: e.target.value})}
                  >
                    <option value="">---------</option>
                    <option value="CUSTOMER">مشتری</option>
                    <option value="PROVIDER">فروشنده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>نام انبار طرف:</label>
                  <Select
                    value={this.state.refTypeWarehouseId}
                    onChange={(refTypeWarehouseId) => this.setState({refTypeWarehouseId})}
                    options={this.state.wareHousesname}
                    isClearable
                    placeholder="------"
                  />
                </div>
                <div className="formComponent">
                  <label>نوع انبار طرف : </label>
                  <select className="form-control" id="refTypePrimaryWarehouseId" name="refTypePrimaryWarehouseId">
                    <option value="">---------</option>
                    {this.state.wareType.map((wareType, index) => (
                      <option key={index} value={wareType.id}>
                        {wareType.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده کالا"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>نام تامین کننده کالا:</label>

                  <Select
                    value={selectedOption}
                    onChange={this.handleChange}
                    options={this.state.providers}
                    isMulti={false}
                    isClearable={true}
                    id="providerId"
                    placeholder=""
                  /> */}
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده طرف سند"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.refProviderId}
                    setValue={(refProviderId) => this.setState({refProviderId})}
                  />
                  {/* <label> تامین کننده کالا طرف : </label>
                    <Select
                      value={this.state.refProviderId}
                      onChange={(refProviderId) =>
                        this.setState({ refProviderId })
                      }
                      options={this.state.providers}
                      isMulti={false}
                      isClearable={true}
                      id="providerId"
                      placeholder=""
                    /> */}
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور طرف: </label>
                  <input className="form-control" type="text" id="refFactorNo" />
                </div>

                <div className="formComponent">
                  <label>مشتری طرف‌: </label>
                  <input className="form-control" type="text" id="refCustomerId" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                {this.state.Cardex.map((cardex, index) => (
                  <tr key={index} style={cardex.colorable ? {background: cardex.background} : {background: ''}}>
                    <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                    <td>{jMoment(cardex.confirmDate).format('jYYYY/jMM/jDD HH:mm')}</td>
                    <td>{cardex.globalDocNo}</td>
                    <td>
                      {cardex.manualRegisterDate == null
                        ? '-'
                        : jMoment(cardex.manualRegisterDate).format('jYYYY/jMM/jDD')}
                    </td>
                    <td>{cardex.articleId}</td>
                    <td>{cardex.productCode}</td>
                    <td>
                      <a target="_blank" href={productShop({articleId: cardex.articleId})}>
                        {cardex.productName}
                      </a>
                    </td>
                    <td>{cardex.warehouseName}</td>
                    <td>{cardex.refTypeWarehouseName}</td>
                    <td>{cardex.inQuantity}</td>
                    <td>{cardex.outQuantity}</td>
                    <td>{cardex.remainQuantity}</td>
                    <td>
                      <Link to={`/ShowPreRecord/${cardex.preWarehouseDocId}`} target="_blank">
                        {cardex.preWarehouseDocId}
                      </Link>
                    </td>
                    <td>
                      <Link to={`/showRecord/${cardex.preWarehouseDocId}/${cardex.natureDocNo}`} target="_blank">
                        {cardex.natureDocNo}
                      </Link>
                    </td>
                    {/*<td>{cardex.globalOperationNo}</td>*/}
                    <td>{cardex.input ? 'وارده' : 'صادره'}</td>
                    <td>{cardex.providerName}</td>
                  </tr>
                ))}
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthCardex}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Cardex
